import { History } from 'lucide-react';
import { sameSet } from '../lib/groups';

/** «Отмечено как в прошлый раз · 5 — Сбросить»: набор по умолчанию виден и снимается одним нажатием. */
export function LastSetNotice({ applied, checked, lastIds, availableIds, onReset }: {
  applied: boolean;
  checked: ReadonlySet<string>;
  lastIds: readonly string[];
  availableIds: readonly string[];
  onReset: () => void;
}) {
  const available = new Set(availableIds);
  const last = lastIds.filter((id) => available.has(id));
  if (!applied || checked.size === 0 || !sameSet(checked, last)) return null;
  return (
    <div className="mb-2 flex flex-wrap items-center gap-2 rounded-md bg-muted/60 px-2.5 py-1.5 text-xs text-muted-foreground">
      <History className="size-3.5" />
      <span>Отмечено как в прошлый раз · {checked.size}</span>
      <button type="button" className="font-medium text-foreground underline" onClick={onReset}>Сбросить</button>
    </div>
  );
}
